import { createContext, useContext, type ReactNode } from 'react';
import type { PostFull, PostSummary } from '../lib/sanity';
import type { NavDropdownLink } from '../components/nav/NavDropdown';
import type { UseCasePageData } from '../lib/useCaseQueries';

export type PrerenderData = {
  posts?: PostSummary[];
  post?: PostFull | null;
  relatedPosts?: PostSummary[];
  useCase?: UseCasePageData | null;
  useCaseNavLinks?: NavDropdownLink[];
};

const PrerenderDataContext = createContext<PrerenderData | null>(null);

export function PrerenderDataProvider({
  value,
  children,
}: {
  value: PrerenderData;
  children: ReactNode;
}) {
  return <PrerenderDataContext.Provider value={value}>{children}</PrerenderDataContext.Provider>;
}

export function usePrerenderData() {
  return useContext(PrerenderDataContext);
}
